/**
 * Custodian account/lot IDs are stored without dashes, but users often paste
 * dashed values into Views search. Strip dashes from ID-like terms (contain a
 * digit) before the SORM request so paste-and-search works; leave pure text
 * alone so hyphenated names still match as typed.
 */
export function normalizeDashedSearchTerm(searchTerm: string): string {
  const hasDash = searchTerm.includes('-')
  const hasDigit = /\d/.test(searchTerm)

  if (!hasDash || !hasDigit) {
    return searchTerm
  }

  return searchTerm.replaceAll('-', '')
}
